import React, { useRef } from "react"
import Col from "antd/lib/col"
import Collapse from "antd/lib/collapse"
import Form from "antd/lib/form"
import Row from "antd/lib/row"
import Select from "antd/lib/select"
import ExpenseTag from "Components/expenseTag"
import { doFilterSelect } from "Shared/utils/helpers"
import { useExpenseTags } from "Shared/hooks/expenseTags.hooks"
import { ExpenseTag as ExpenseTagInterface } from "@finway-group/shared/lib/models/expense/expenseTag.enum"
import { getPopupAnchor } from "Shared/utils/popup.utils"

interface FormExpenseTagsInterface {
    header: string
    initialValue?: ExpenseTagInterface[]
    keyCode?: string
    placeholder: string
}

export default function FormExpenseTags({ header, initialValue = [], placeholder, keyCode = "0" }: FormExpenseTagsInterface) {
    const expenseTags = useExpenseTags()
    const anchorRef = useRef(null)

    return (
        <>
            {/* empty div to fix ant-design bug for non-sticky dropdowns */}
            <div ref={anchorRef} />
            <Collapse ghost defaultActiveKey={keyCode}>
                <Collapse.Panel header={header} key={keyCode}>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item name="expenseTags" style={{ marginBottom: "0px" }} initialValue={initialValue}>
                                <Select
                                    showSearch
                                    showArrow
                                    mode="multiple"
                                    placeholder={placeholder}
                                    filterOption={doFilterSelect}
                                    tagRender={renderCustomTag}
                                    getPopupContainer={getPopupAnchor(anchorRef.current)}
                                >
                                    {expenseTags.map(({ _id, tagColor, tagName }) => (
                                        <Select.Option key={_id} value={_id} label={tagName}>
                                            <ExpenseTag color={tagColor} label={tagName}>
                                                {tagName}
                                            </ExpenseTag>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Collapse.Panel>
            </Collapse>
        </>
    )
}

const renderCustomTag = (props: any) => {
    const { label, onClose } = props

    if (!label?.props) return <></>

    return (
        <ExpenseTag color={label.props.color} onClose={onClose} closable>
            {` ${label.props.label} `}
        </ExpenseTag>
    )
}
